import * as React from 'react';
import { jobsModeType } from '../../Jobs';

interface Props {
  jobEmails: { customerId?: string; email: string }[];
  wizardMode: jobsModeType;
}

function JobWizardEmails({ jobEmails, wizardMode }: Props) {
  const title =
    wizardMode === 'SCHOOL_CUSTOMERS' || wizardMode === 'SCHOOL_EMAILS'
      ? 'Sending list (whole school)'
      : 'Sending list';

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="mt-3">
            <h3>{title}</h3>
            {jobEmails.map(email => (
              <div key={email.email}>{email.email}</div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default JobWizardEmails;
